type SectionTitleProps = {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
};

export default function SectionTitle({
  eyebrow,
  title,
  desc,
  align = "left",
}: SectionTitleProps) {
  const isCenter = align === "center";
  return (
    <div className={`mb-8 md:mb-12 ${isCenter ? "text-center max-w-2xl mx-auto" : "max-w-2xl"}`}>
      {eyebrow && (
        <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-800 text-xs font-medium mb-3">
          <span className="w-1.5 h-1.5 rounded-full bg-primary-500" aria-hidden="true"></span>
          {eyebrow}
        </span>
      )}
      <h2
        className="text-2xl md:text-4xl font-bold text-foreground-950 leading-snug"
        style={{ fontFamily: "var(--font-heading)" }}
      >
        {title}
      </h2>
      {desc && <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>}
    </div>
  );
}